import React, { useEffect } from "react";
import { useSelector } from "react-redux";

export default function Daughter2Proposerdisplay() {
    const ownerInfo = useSelector((state) => state?.addressdetail?.info1);
; 
  return (
    <>
    <div className="d-flex px-3 row row-cols-xl-3 row-cols-lg-3 row-cols-md-2 row-cols-sm-1 row-cols-1">
      <div className="py-2 px-2 text-nowrap col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
        <div className="indivtexthead">FULL NAME</div>
        <div className="indivtext">{ownerInfo?.Daughter2?.title}. {' '}{ownerInfo?.Daughter2?.Daugh1Name}</div>
      </div>
      <div className="py-2 px-2 text-nowrap col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
        <div className="indivtexthead">DATE OF BIRTH</div>
        <div className="indivtext">{ownerInfo?.Daughter2?.dateofbirth}</div>
      </div>
      <div className="py-2 px-2 text-nowrap col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
        <div className="indivtexthead">Height</div>
        <div className="indivtext">{ownerInfo?.Daughter2?.DaughHeight}{' '}{ownerInfo?.Daughter2?.DaughInches}</div>
      </div>
      <div className="py-2 px-2 text-nowrap col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
        <div className="indivtexthead">Weight</div>
        <div className="indivtext">{ownerInfo?.Daughter2?.DaughWeight}{' '}kg</div>
      </div>
      <div className="py-2 px-2 text-nowrap col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
        <div className="indivtexthead">Blood Group</div>
        <div className="indivtext">{ownerInfo?.Daughter2?.DaughBloodGroup}</div>
      </div>
    </div>
    </>
  );
}
